import { Helmet } from 'react-helmet-async';
import ClinicProductsView from 'src/sections/clinic-dashboard/products/products-view';

export default function ClinicProductsPage() {
  return (
    <>
      <Helmet>
        <title>Clinic Products</title>
      </Helmet>

      <ClinicProductsView />
    </>
  );
}
